export default __webpack_public_path__ + "static/media/EstacoesIconGray.52f24e4a.svg";